import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["onFocusin", "onFocusout", "onKeydown", "value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_date_picker = _resolveComponent("date-picker")!

  return (_openBlock(), _createBlock(_component_date_picker, {
    ref: "datepicker",
    modelValue: _ctx.field.date,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.field.date) = $event)),
    attributes: _ctx.field.attributes,
    locale: _ctx.field.locale,
    "max-date": _ctx.maxDate,
    "min-date": _ctx.minDate,
    "disabled-dates": _ctx.disabledDates,
    "update-on-input": false
  }, {
    default: _withCtx(({ inputValue, hidePopover, showPopover }) => [
      _createElementVNode("input", {
        onFocusin: ($event: any) => (showPopover()),
        onFocusout: ($event: any) => (hidePopover()),
        onKeydown: ($event: any) => (_ctx.onInputKeyDown($event, showPopover)),
        onKeyup: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.updateValueByInput && _ctx.updateValueByInput(...args))),
        value: inputValue,
        "max-length": "10"
      }, null, 40, _hoisted_1)
    ]),
    _: 1
  }, 8, ["modelValue", "attributes", "locale", "max-date", "min-date", "disabled-dates"]))
}